import axios from "axios"
import {trackAPICall} from "../utils/mixpanel" // Add this import

const baseURL = "https://dashboard.plaex.net/api/";
// const baseURL = "http://127.0.0.1:8000/api/";

const axiosInstance = axios.create({
    baseURL: baseURL,
    headers: {
        accept: "application/json",
    },
})

axiosInstance.defaults.xsrfCookieName = "csrftoken"
axiosInstance.defaults.xsrfHeaderName = "X-CSRFToken"
axiosInstance.defaults.withCredentials = true

// ✅ Add request interceptor to track API calls
axiosInstance.interceptors.request.use(
    (config) => {
        // Track API request start
        config.metadata = {startTime: new Date()}
        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

// ✅ Enhanced response interceptor with Mixpanel tracking
axiosInstance.interceptors.response.use(
    (response) => {
        // Track successful API call
        const duration = new Date() - response.config.metadata.startTime

        trackAPICall(response.config.url, response.config.method.toUpperCase(), true, {
            status_code: response.status,
            duration_ms: duration,
            response_size: JSON.stringify(response.data).length,
        })

        return response
    },
    async (error) => {
        // Track failed API call
        if (error.config && error.config.metadata) {
            const duration = new Date() - error.config.metadata.startTime

            trackAPICall(error.config.url, error.config.method.toUpperCase(), false, {
                status_code: error.response?.status || 0,
                duration_ms: duration,
                error_type: error.response?.status === 403 ? "forbidden" : "api_error",
                error_message: error.message,
            })
        }

        // Your existing error handling
        if (error.response?.status === 403) {
            window.location.href = "/"
            localStorage.removeItem("loggedin")
            return Promise.reject(error)
        }

        return Promise.reject(error)
    },
)

export default axiosInstance